export default __webpack_public_path__ + "static/media/Raleway-Medium.1af9f1e9.ttf";